/* eslint no-undef: 0, no-param-reassign: 0 */

function easeInOutQuad(t, b, c, d) {
  let k = t / (d / 2);
  if (k < 1) return ((c / 2) * k * k) + b;
  k -= 1;
  return ((-c / 2) * ((k * (k - 2)) - 1)) + b;
}

export function scrollElementLeftTo(element, to, duration, done) {
  const start = element.scrollLeft;
  const change = to - start;
  const startDate = Date.now();

  function animateScroll() {
    const currentDate = Date.now();
    const currentTime = currentDate - startDate;
    element.scrollLeft = easeInOutQuad(currentTime, start, change, duration);

    if (currentTime < duration) {
      requestAnimationFrame(animateScroll);
      return;
    } else if (typeof done === 'function') {
      done();
    }

    element.scrollLeft = to;
  }

  animateScroll();
}

export default (to, duration, done) => {
  const element = document.scrollingElement || document.documentElement;
  const start = element.scrollTop;
  const change = to - start;
  const startDate = Date.now();

  function animateScroll() {
    const currentDate = Date.now();
    const currentTime = currentDate - startDate;
    element.scrollTop = easeInOutQuad(currentTime, start, change, duration);
    if (currentTime < duration) {
      requestAnimationFrame(animateScroll);
      return;
    } else if (typeof done === 'function') {
      done();
    }

    element.scrollTop = to;
  }

  animateScroll();
};
